import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const Header = ({ showRightSidebar }) => {
  const { data: languageData } = useSelector(
    (state) => state.getLanguageSettingsSlicer
  );

  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsFixed(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`header navbar navbar-expand bg-white ${
        isFixed ? "shadow-sm fixed-top" : ""
      }`}
    >
      <div className="container-fluid d-flex align-items-center">
        <i
          className="bi bi-list fs-1 ms-auto text-black"
          role="button"
          aria-label="Toggle Sidebar"
          onClick={showRightSidebar}
          style={{ cursor: "pointer" }}
        ></i>
      </div>
    </header>
  );
};

export default Header;
